import React from "react";
import { useQuery } from "react-query";
import { getActiveAadeCases } from "./gateway";
import { useAuth } from "src/shared/context/useAuth";
import { MRT_PaginationState } from "material-react-table";

export default function useGetActiveAadeCase({
  filters,
  enabled,
  setEnableSearch,
  tab,
  paginationState,
}: {
  enabled: Boolean;
  filters: Object;
  setEnableSearch: React.Dispatch<React.SetStateAction<Boolean>>;
  tab: Number;
  paginationState: MRT_PaginationState;
}) {
  const { isOrgAdmin, isSystemAdmin } = useAuth();

  const fetchForEntireChamber = tab === 1 && isOrgAdmin;

  return useQuery({
    queryFn: () =>
      getActiveAadeCases(filters, paginationState, fetchForEntireChamber),
    queryKey: ["active-aadeCases", filters, tab, paginationState],
    onSettled: () => {
      setEnableSearch(false);
    },
    enabled: !!enabled,
  });
}
